import { useEffect } from 'react';
import routerPaths from '../util/routerPaths';
import { actions } from '../util/actions';

export const useErrorPage = (history, data) => {
  useEffect(() => {
    if (
      history.location.pathname !== routerPaths.ERROR &&
      (data.action === actions.error ||
        data?.error ||
        new URLSearchParams(history.location.search).has('error'))
    ) {
      history.push(routerPaths.ERROR + history.location.search);
    }
  }, [data?.action, data?.error, history]);
};
